<style>
/* .table-responsive,
.dataTables_scrollBody {
    overflow: visible !important;
} */
/* div.dataTables_scrollBody.dropdown-visible {
  overflow: visible !important;
} */

/* table .dropdown-menu {
    position: fixed !important;
    top: 50% !important;
    left: 92% !important;
    transform: translate(-92%, -50%) !important;
} */

/* .dataTables_scrollHead{
    position: static !important;
} */
</style>
<template>
  <div>
    <div>
      <!-- <div style="overflow-x:auto;"> -->
      <table id="example" class="table" style="width: 100%">
        <thead>
          <tr>
            <th class="all">No</th>
            <th class="all">Nomor Pemohon</th>
            <th>Instansi Pemohon</th>
            <th class="all">Jenis Kegiatan</th>
            <th class="all">Nama Perairan</th>
            <th class="all">Provinsi</th>
            <th>Status Verdok</th>
            <th>Status Permohonan</th>
            <th>Tgl. Permohonan</th>
            <th>Tgl. Verdok</th>
            <th v-if="tipe == 'Swasta'">Tgl. Berlaku Tagihan</th>
            <th v-if="tipe == 'Swasta'">Status Tagihan</th>
            <th style="text-align: center">File</th>
            <!-- <th>File Surat Tugas</th>
                        <th>File Undangan</th>
                        <th>File BA</th>
                        <th>File Memo</th> -->
            <th class="all">Aksi</th>
          </tr>
          <!-- <tr>
                        <th>Bukti Pembayaran</th>
                        <th>Surat Tugas</th>
                        <th>Undangan</th>
                        <th>BA</th>
                        <th>Memo</th>
                        <th>Persetujuan</th>
                    </tr> -->
        </thead>
        <tbody>
          <tr v-for="data in dataPermohonan" :key="data.id">
            <td class="sticky-col second-col">
              <span
                v-if="data.catatan_verdok !== null"
              ></span>
              <span v-else>
                <div
                  :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]"
                ></div>
              </span>
            </td>
            <td>
                  <span
                    class="badge rounded-pill bg-success"
                    style="font-size: 10px; font-weight: normal"
                    v-if="data.nomor_permohonan != null"
                    >{{ data.nomor_permohonan }}</span
                  >
                  <span
                    class="badge rounded-pill bg-danger"
                    style="
                      font-size: 10px;
                      font-weight: normal;
                      background-color: #ff6e7c !important;
                    "
                    v-else
                    >Belum Ada</span
                  >
                </td>
            <td style="word-wrap: break-word;min-width: 200px;max-width: 200px;white-space:normal;">{{ data.instansi_pemohon }}</td>

            <td style="word-wrap: break-word;min-width: 200px;max-width: 200px;white-space:normal;">
              <span v-if="data.catatan_verdok !== null">{{
                data.jenis_kegiatan
              }}</span>
              <span v-else>
                <div
                  :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]"
                >
                  {{ data.jenis_kegiatan }}
                </div>
              </span>
            </td>
            <td>
              <span v-if="data.catatan_verdok !== null">{{
                data.nama_perairan
              }}</span>
              <span v-else>
                <div
                  :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]"
                >
                  {{ data.nama_perairan }}
                </div>
              </span>
            </td>
            <td>
              <span v-if="data.catatan_verdok !== null">{{
                data.provinsi
              }}</span>
              <span v-else>
                <div
                  :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]"
                >
                  {{ data.provinsi }}
                </div>
              </span>
            </td>
            <td>
              <span v-if="data.catatan_verdok !== null">{{
                data.status_verdok
              }}</span>
              <span v-else>
                <div
                  :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]"
                >
                  {{ data.status_verdok }}
                </div>
              </span>
            </td>
            
            <td>{{ data.status_permohonan }}</td>
            <td>
              {{ format_date(data.tanggal_permohonan, "DD MMMM YYYY") }}
            </td>
            <td>
              {{
                format_date(
                  data.tanggal_lolos_verifikasi_administrasi,
                  "DD MMMM YYYY"
                )
              }}
            </td>
            <td v-if="tipe == 'Swasta'">
              <span v-if="data.status_tagihan_iii != null">
                {{ format_date(data.tanggal_berlaku_hingga_tagihan_iii) }}
              </span>
              <span
                v-else-if="
                  data.status_tagihan_ii != null && data.status_tagihan_i != null
                "
              >
                {{ format_date(data.tanggal_berlaku_hingga_tagihan_ii) }}
              </span>
              <span v-else>
                {{ format_date(data.tanggal_berlaku_hingga_tagihan_i) }}
              </span>
            </td>
            <td v-if="tipe == 'Swasta'">
              <span v-if="data.status_tagihan_iii != null">
                {{ data.status_tagihan_iii }}
              </span>
              <span
                v-else-if="
                  data.status_tagihan_ii != null && data.status_tagihan_i != null
                "
              >
                {{ data.status_tagihan_ii }}
              </span>
              <span v-else>
                {{ data.status_tagihan_i }}
              </span>
            </td>
            <td>
              <div style="width: 250px">
                <div class="row">
                  <div class="col-md-8">
                    <select
                      v-model="data.selectedFile"
                      style="width: 150px; margin-right: 10px"
                      class="form-select"
                      aria-label="Default select example"
                    >
                      <option disabled value="">- Pilih File -</option>
                      <option
                        value="verdok"
                        :disabled="
                          data.file_ba_verdok == null
                        "
                      >
                        Verdok
                      </option>
                      <option
                        value="tagihan"
                        :disabled="
                          data.file_tagihan_ii == null &&
                          data.file_tagihan_i == null &&
                          data.file_tagihan_iii == null
                        "
                      >
                        <i class="la la-edit"></i> Tagihan
                      </option>
                      <option
                        value="pembayaran"
                        :disabled="data.bukti_pembayaran == null"
                      >
                        Bukti Pembayaran
                      </option>
                      <option
                        value="surattugas"
                        :disabled="
                          data.filename_final_surat_tugas == null &&
                          data.filename_konsep_surat_tugas == null
                        "
                      >
                        Surat Tugas
                      </option>
                      <option
                        value="undangan"
                        :disabled="
                          data.filename_final_undangan == null &&
                          data.filename_konsep_undangan == null
                        "
                      >
                        Undangan
                      </option>
                      <option value="ba" :disabled="data.file_ba_vertek == null">
                        Berita Acara
                      </option>
                      <option
                        value="memo"
                        :disabled="
                          data.file_final_memorandum == null &&
                          data.file_konsep_memorandum == null
                        "
                      >
                        Memorendum
                      </option>
                      <option
                        value="persetujuan"
                        :disabled="data.file_persetujuan == null"
                      >
                        Draft Surat Persetujuan
                      </option>
                      <option
                        value="final-persetujuan"
                        :disabled="data.file_izin_ttd == null"
                      >
                        Final Surat Persetujuan
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4 mt-2">
                    <span
                      v-if="
                        data.file_ba_verdok != null &&
                        data.selectedFile == 'verdok'
                      "
                    >
                      <a :href="data.file_ba_verdok" target="_blank"
                        ><i
                          class="fa fa-cloud-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file verifikasi dokumen"
                      /></a>
                    </span>
                    <span
                      v-if="
                        data.file_tagihan_iii != null &&
                        data.selectedFile == 'tagihan'
                      "
                    >
                      <a :href="data.file_tagihan_iii" target="_blank"
                        ><i
                          class="fa fa-cloud-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file tagihan"
                      /></a>
                    </span>
                    <span
                      v-else-if="
                        data.file_tagihan_ii != null &&
                        data.file_tagihan_i != null &&
                        data.selectedFile == 'tagihan'
                      "
                    >
                      <a :href="data.file_tagihan_ii" target="_blank"
                        ><i
                          class="fa fa-cloud-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file tagihan"
                        />
                      </a>
                    </span>
                    <span
                      v-else-if="
                        data.file_tagihan_i != null &&
                        data.selectedFile == 'tagihan'
                      "
                    >
                      <a :href="data.file_tagihan_i" target="_blank"
                        ><i
                          class="fa fa-cloud-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file tagihan"
                      /></a>
                    </span>

                    <!-- <br> -->
                    <span
                      v-if="
                        data.bukti_pembayaran != null &&
                        data.selectedFile == 'pembayaran'
                      "
                    >
                      <a :href="data.bukti_pembayaran" target="_blank"
                        ><i
                          class="fa fa-cloud-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file bukti pembayaran"
                        />
                      </a>
                    </span>

                    <span
                      v-if="
                        data.filename_final_surat_tugas != null &&
                        data.selectedFile == 'surattugas'
                      "
                    >
                      <a :href="data.filename_final_surat_tugas" target="_blank"
                        ><i
                          class="fa fa-cloud-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file surat tugas"
                      /></a>
                    </span>
                    <span
                      v-else-if="
                        data.filename_konsep_surat_tugas != null &&
                        data.selectedFile == 'surattugas'
                      "
                    >
                      <a :href="data.filename_konsep_surat_tugas" target="_blank"
                        ><i
                          class="fa fa-cloud-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file surat tugas"
                      /></a>
                    </span>

                    <span
                      v-if="
                        data.filename_final_undangan != null &&
                        data.selectedFile == 'undangan'
                      "
                    >
                      <a :href="data.filename_final_undangan" target="_blank"
                        ><i
                          class="fa fa-cloud-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file undangan"
                      /></a>
                    </span>
                    <span
                      v-else-if="
                        data.filename_konsep_undangan != null &&
                        data.selectedFile == 'undangan'
                      "
                    >
                      <a :href="data.filename_konsep_undangan" target="_blank"
                        ><i
                          class="fa fa-cloud-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file undangan"
                      /></a>
                    </span>

                    <span
                      v-if="
                        data.file_ba_vertek != null && data.selectedFile == 'ba'
                      "
                    >
                      <a :href="data.file_ba_vertek" target="_blank"
                        ><i
                          class="fa fa-cloud-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file berita acara"
                      /></a>
                    </span>

                    <span
                      v-if="
                        data.file_final_memorandum != null &&
                        data.selectedFile == 'memo'
                      "
                    >
                      <a :href="data.file_final_memorandum" target="_blank"
                        ><i
                          class="fa fa-cloud-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file memo"
                      /></a>
                    </span>
                    <span
                      v-else-if="
                        data.file_konsep_memorandum != null &&
                        data.selectedFile == 'memo'
                      "
                    >
                      <a :href="data.file_konsep_memorandum" target="_blank"
                        ><i
                          class="fa fa-cloud-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file memo"
                      /></a>
                    </span>

                    <span
                      v-if="
                        data.file_persetujuan != null &&
                        data.selectedFile == 'persetujuan'
                      "
                    >
                      <a :href="data.file_persetujuan" target="_blank"
                        ><i
                          class="fa fa-cloud-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file persetujuan"
                        />
                      </a>
                    </span>

                    <span
                      v-if="
                        data.file_izin_ttd != null &&
                        data.selectedFile == 'final-persetujuan'
                      "
                    >
                      <a :href="data.file_izin_ttd" target="_blank"
                        ><i
                          class="fa fa-cloud-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file persetujuan"
                        />
                      </a>
                    </span>
                  </div>
                </div>

                <!-- <b-form-select style="width: 150px;margin-right: 20px;" v-model="data.selectedFile"
                                    :options="optionsFile"></b-form-select> -->
              </div>
            </td>

            <!-- <td>
                            <div>
                                <span v-if="data.file_tagihan_iii != null">
                                    <a :href="data.file_tagihan_iii" target="_blank"><i class="fa fa-download"
                                            aria-hidden="true" /> Unduh Tagihan</a>
                                </span>
                                <span v-else-if="data.file_tagihan_ii != null && data.file_tagihan_i != null">
                                    <a :href="data.file_tagihan_ii" target="_blank"><i class="fa fa-download"
                                            aria-hidden="true" /> Unduh Tagihan</a>
                                </span>
                                <span v-else-if="data.file_tagihan_i != null">
                                    <a :href="data.file_tagihan_i" target="_blank"><i class="fa fa-download"
                                            aria-hidden="true" /> Unduh Tagihan</a>
                                </span>
                            </div>
                            <span v-if="data.bukti_pembayaran != null">
                                <a :href="data.bukti_pembayaran" target="_blank"><i class="fa fa-download"
                                        aria-hidden="true" /> Unduh Bukti Pembayaran</a>
                            </span>
                        </td>
                        <td>
                            <span v-if="data.filename_final_surat_tugas != null">
                                <a :href="data.filename_final_surat_tugas" target="_blank"><i class="fa fa-download"
                                        aria-hidden="true" /> Unduh</a>
                            </span>
                            <span v-else-if="data.filename_konsep_surat_tugas != null">
                                <a :href="data.filename_konsep_surat_tugas" target="_blank"><i class="fa fa-download"
                                        aria-hidden="true" /> Unduh</a>
                            </span>
                        </td>
                        <td>
                            <span v-if="data.filename_final_undangan != null">
                                <a :href="data.filename_final_undangan" target="_blank"><i class="fa fa-download"
                                        aria-hidden="true" /> Unduh</a>
                            </span>
                            <span v-else-if="data.filename_konsep_undangan != null">
                                <a :href="data.filename_konsep_undangan" target="_blank"><i class="fa fa-download"
                                        aria-hidden="true" /> Unduh</a>
                            </span>
                        </td>
                        <td>
                            <span v-if="data.file_ba_vertek != null">
                                <a :href="data.file_ba_vertek" target="_blank"><i class="fa fa-download"
                                        aria-hidden="true" /> Unduh</a>
                            </span>
                        </td>
                        <td>
                            <span v-if="data.file_final_memorandum != null">
                                <a :href="data.file_final_memorandum" target="_blank"><i class="fa fa-download"
                                        aria-hidden="true" /> Unduh</a>
                            </span>
                            <span v-else-if="data.file_konsep_memorandum != null">
                                <a :href="data.file_konsep_memorandum" target="_blank"><i class="fa fa-download"
                                        aria-hidden="true" /> Unduh</a>
                            </span>
                        </td>
                        <td>
                            <span v-if="data.file_persetujuan != null">
                                <a :href="data.file_persetujuan" target="_blank"><i class="fa fa-download"
                                        aria-hidden="true" /> Unduh</a>
                            </span>
                        </td> -->
            <td>
              <!-- <b-button
                size="sm"
                variant="success"
                data-toggle="tooltip"
                v-if="data.status_pembuatan_memorandum === 'Selesai'"
                data-placement="top"
                :title="
                  data.file_izin_ttd == null
                    ? 'Unggah Surat Persetujuan'
                    : 'Unggah Ulang Surat Persetujuan'
                "
                @click="detailFinalSurat(data)"
                class="text-white"
                ><i class="fa fa-cloud-upload" /> {{data.file_izin_ttd == null
                    ? 'Unggah Surat Persetujuan'
                    : 'Unggah Ulang Surat Persetujuan'}}</b-button
              > -->
              <b-button size="sm"
                variant="info"
                data-toggle="tooltip"
                data-placement="top"
                title="Detail"
                @click="
                  $router.push('/app/perizinan/detail-perizinan/' + data.id)
                "
                class="text-white m-1"
                ><i class="fa fa-eye" /> Detail</b-button
              >
              
              <b-button size="sm"
                style="margin-left: 5px"
                v-if="
                  data.ttd_ba_vertek_1_status === true &&
                  data.ttd_ba_vertek_2_status === true &&
                  data.ttd_ba_vertek_3_status === true &&
                  data.ttd_ba_vertek_4_status === true &&
                  data.nomor_ba_vertek == null
                "
                @click="
                  idpermohonan = data.id;
                  $bvModal.show('modal-final-ba');
                "
                variant="primary"
                ><i class="fa fa-tasks" /> Finalisasi BA</b-button
              >
              <b-button size="sm"
                style="margin-left: 5px"
                v-if="
                  data.nomor_ba_vertek != null && data.paraf_1_putusan_status != true && data.nomor_kkp == null &&
                  ( (tipe == 'Swasta' && data.bukti_pembayaran != null) || (tipe == 'Pemerintah' && data.bukti_pembayaran == null))
                "
                @click="
                idpermohonan = data.id;
                getDetailPerDokumen(data.id)"
                variant="info"
                ><i class="fa fa-fax" /> Memo</b-button
              >
              <b-button
                size="sm"
                style="margin-left: 5px"
                v-else-if="data.paraf_1_putusan_status == true && data.nomor_kkp == null"
                v-b-modal.modal-final-memo
                @click="
                  idpermohonan = data.id;
                "
                variant="primary"
                ><i class="fa fa-tasks" /> Input Nomor KKP</b-button
              >

              <b-button size="sm"
                style="margin-left: 5px"
                v-else-if="
                  data.paraf_1_putusan_status == true && data.nomor_kkp != null
                "

                @click="
                  tandaTanganMKP(data.id)
                "
                variant="success"
                ><i class="fa fa-file" /> Tanda Tangan Elektronik MKP</b-button
              >

              <!-- <b-button size="sm"
                style="margin-left: 5px"
                v-if="
                  data.bukti_pembayaran == null && data.file_tagihan_i != null && tipe == 'Swasta'
                "
                @click="getBayar(data.id)"
                variant="info"
                ><i class="fa fa-money" /> Pembayaran</b-button
              > -->
              <b-button size="sm"
                  class="m-1"
                    variant="primary"
                    @click="$emit('loadProgress', data.id)"
                    >
                      <i class="fa fa-search"></i> Tracking</b-button
                    >
              <!-- <b-dropdown variant="primary" split text="Aksi" class="me-3">
                                <b-dropdown-item @click="$router.push('/app/perizinan/detail-verifikasi-teknis/'+ data.id)">Penilaian Teknis</b-dropdown-item>
                                <b-dropdown-item v-if="data.status_tandatangan_undangan === true" @click="$router.push('/app/perizinan/ba/'+ data.id)">Pembuatan BA</b-dropdown-item>
                                <b-dropdown-item @click="getDetailPerDokumen(data.id)">Memo Persetujuan</b-dropdown-item>
                            </b-dropdown> -->
            </td>

            
          </tr>
        </tbody>
      </table>
      <!-- </div> -->
    </div>

    <!-- modal Final BA -->
    <b-modal
      body-class="bg-white"
      id="modal-final-ba"
      title="Finalisasi Berita Acara"
      cancel-title="Close"
      ok-title="Accept"
      size="md"
      cancel-variant="outline-secondary"
    >
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
          <b-col md="12">
            <b-form-group label="Nomor Berita Acara: *">
              <input
                :class="{ 'form-control': true }"
                type="txt"
                v-validate="'required'"
                name="Nomor Berita Acara"
                v-model="nomorBA"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="finalBA">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal nomor memo -->
    <b-modal
      body-class="bg-white"
      id="modal-final-memo"
      title="Finalisasi Memo"
      cancel-title="Close"
      ok-title="Accept"
      size="md"
      cancel-variant="outline-secondary"
    >
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
          <b-col md="12">
            <b-form-group label="Nomor KKP: *">
              <input
                :class="{ 'form-control': true }"
                type="txt"
                v-validate="'required'"
                name="Nomor KKP"
                v-model="dataPerDokumen.nomor_kkp"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="finalMemo">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal memo -->
    <b-modal
      body-class="bg-white"
      id="modal-memo"
      size="xl"
      title="Memo Persetujuan"
      cancel-title="Close"
      ok-title="Accept"
      cancel-variant="outline-secondary"
    >
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row v-if="this.dataPerDokumen.status_pembuatan_memorandum != null">
          <b-col
            v-if="
              this.dataPerDokumen.status_pembuatan_memorandum.includes(
                'Catatan'
              )
            "
            md="12"
          >
            <b-alert show variant="info">
              <span
                ><span class="fw-semi-bold">Info:</span> Terdapat Catatan
                Perbaikan.
                <a
                  type="button"
                  data-toggle="modal"
                  data-target=".catatan"
                  class="btn btn-default btn-xs float-end me-1"
                  @click="getCatatanMemo(dataPerDokumen.id)"
                  >Lihat Catatan</a
                ></span
              >
            </b-alert>
          </b-col>
        </b-row>
        <legend><strong>Memo 1</strong></legend>
        <b-row>
          <b-col md="4">
            <b-form-group label="Paraf 1 Memo : *">
              <v-select
                id="default-select"
                v-model="dataPerDokumen.paraf_1_memo_1"
                :options="dataTTD"
                :reduce="(user) => user.id_user"
                v-validate="'required'"
                name="Paraf 1 Memo"
                :class="{ 'is-invalid': errors.has('form-1.Paraf 1 Memo') }"
                label="nama_lengkap"
              />
              <span
                class="text-danger"
                v-if="errors.has('form-1.Paraf 1 Memo')"
              >
                {{ errors.first("form-1.Paraf 1 Memo") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Paraf 2 Memo : *">
              <v-select
                id="default-select"
                v-model="dataPerDokumen.paraf_2_memo_1"
                :options="dataTTD"
                v-validate="'required'"
                name="Paraf 2 Memo"
                :class="{ 'is-invalid': errors.has('form-1.Paraf 2 Memo') }"
                :reduce="(user) => user.id_user"
                label="nama_lengkap"
              />
              <span
                class="text-danger"
                v-if="errors.has('form-1.Paraf 2 Memo')"
              >
                {{ errors.first("form-1.Paraf 2 Memo") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Tandatangan Memo : *">
              <v-select
                id="default-select"
                v-model="dataPerDokumen.ttd_memo_1"
                :options="dataTTD"
                v-validate="'required'"
                name="Tandatangan Memo"
                :class="{ 'is-invalid': errors.has('form-1.Tandatangan Memo') }"
                :reduce="(user) => user.id_user"
                label="nama_lengkap"
              />
              <span
                class="text-danger"
                v-if="errors.has('form-1.Tandatangan Memo')"
              >
                {{ errors.first("form-1.Tandatangan Memo") }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <legend><strong>Memo 2</strong></legend>
        <b-row>
          <b-col md="4">
            <b-form-group label="Paraf 1 Memo : *">
              <v-select
                id="default-select"
                v-model="dataPerDokumen.paraf_1_memo_2"
                :options="dataTTD"
                v-validate="'required'"
                name="Paraf 1 Memo"
                :class="{ 'is-invalid': errors.has('form-1.Paraf 1 Memo') }"
                :reduce="(user) => user.id_user"
                label="nama_lengkap"
              />
              <span
                class="text-danger"
                v-if="errors.has('form-1.Paraf 1 Memo')"
              >
                {{ errors.first("form-1.Paraf 1 Memo") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Paraf 2 Memo : *">
              <v-select
                id="default-select"
                v-model="dataPerDokumen.paraf_2_memo_2"
                :options="dataTTD"
                v-validate="'required'"
                name="Paraf 2 Memo"
                :class="{ 'is-invalid': errors.has('form-1.Paraf 2 Memo') }"
                :reduce="(user) => user.id_user"
                label="nama_lengkap"
              />
              <span
                class="text-danger"
                v-if="errors.has('form-1.Paraf 2 Memo')"
              >
                {{ errors.first("form-1.Paraf 2 Memo") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Paraf 3 Memo : *">
              <v-select
                id="default-select"
                v-model="dataPerDokumen.paraf_3_memo_2"
                :options="dataTTD"
                v-validate="'required'"
                name="Paraf 3 Memo"
                :class="{ 'is-invalid': errors.has('form-1.Paraf 3 Memo') }"
                :reduce="(user) => user.id_user"
                label="nama_lengkap"
              />
              <span
                class="text-danger"
                v-if="errors.has('form-1.Paraf 3 Memo')"
              >
                {{ errors.first("form-1.Paraf 3 Memo") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Tandatangan Memo : *">
              <v-select
                id="default-select"
                v-model="dataPerDokumen.ttd_memo_2"
                :options="dataTTD"
                v-validate="'required'"
                name="Tandatangan Memo"
                :class="{ 'is-invalid': errors.has('form-1.Tandatangan Memo') }"
                :reduce="(user) => user.id_user"
                label="nama_lengkap"
              />
              <span
                class="text-danger"
                v-if="errors.has('form-1.Tandatangan Memo')"
              >
                {{ errors.first("form-1.Tandatangan Memo") }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <legend><strong>Putusan</strong></legend>
        <b-row>
          <b-col md="4">
            <b-form-group label="Paraf 1 Putusan : *">
              <v-select
                id="default-select"
                v-model="dataPerDokumen.paraf_1_putusan"
                :options="dataTTD"
                v-validate="'required'"
                name="Paraf 1 Putusan"
                :class="{ 'is-invalid': errors.has('form-1.Paraf 1 Putusan') }"
                :reduce="(user) => user.id_user"
                label="nama_lengkap"
              />
              <span
                class="text-danger"
                v-if="errors.has('form-1.Paraf 1 Putusan')"
              >
                {{ errors.first("form-1.Paraf 1 Putusan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Paraf 2 Putusan : *">
              <v-select
                id="default-select"
                v-model="dataPerDokumen.paraf_2_putusan"
                :options="dataTTD"
                v-validate="'required'"
                name="Paraf 2 Putusan"
                :class="{ 'is-invalid': errors.has('form-1.Paraf 2 Putusan') }"
                :reduce="(user) => user.id_user"
                label="nama_lengkap"
              />
              <span
                class="text-danger"
                v-if="errors.has('form-1.Paraf 2 Putusan')"
              >
                {{ errors.first("form-1.Paraf 2 Putusan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Paraf 3 Putusan : *">
              <v-select
                id="default-select"
                v-model="dataPerDokumen.paraf_3_putusan"
                :options="dataTTD"
                v-validate="'required'"
                name="Paraf 3 Putusan"
                :class="{ 'is-invalid': errors.has('form-1.Paraf 3 Putusan') }"
                :reduce="(user) => user.id_user"
                label="nama_lengkap"
              />
              <span
                class="text-danger"
                v-if="errors.has('form-1.Paraf 3 Putusan')"
              >
                {{ errors.first("form-1.Paraf 3 Putusan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Paraf 4 Putusan : *">
              <v-select
                id="default-select"
                v-model="dataPerDokumen.paraf_4_putusan"
                :options="dataTTD"
                v-validate="'required'"
                name="Paraf 4 Putusan"
                :class="{ 'is-invalid': errors.has('form-1.Paraf 4 Putusan') }"
                :reduce="(user) => user.id_user"
                label="nama_lengkap"
              />
              <span
                class="text-danger"
                v-if="errors.has('form-1.Paraf 4 Putusan')"
              >
                {{ errors.first("form-1.Paraf 4 Putusan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Paraf 5 Putusan : *">
              <v-select
                id="default-select"
                v-model="dataPerDokumen.paraf_5_putusan"
                :options="dataTTD"
                v-validate="'required'"
                name="Paraf 5 Putusan"
                :class="{ 'is-invalid': errors.has('form-1.Paraf 5 Putusan') }"
                :reduce="(user) => user.id_user"
                label="nama_lengkap"
              />
              <span
                class="text-danger"
                v-if="errors.has('form-1.Paraf 5 Putusan')"
              >
                {{ errors.first("form-1.Paraf 5 Putusan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Tandatangan Putusan : *">
              <v-select
                id="default-select"
                v-model="dataPerDokumen.ttd_putusan"
                :options="dataTTD"
                v-validate="'required'"
                name="Tandatangan Putusan"
                :class="{
                  'is-invalid': errors.has('form-1.Tandatangan Putusan'),
                }"
                :reduce="(user) => user.id_user"
                label="nama_lengkap"
              />
              <span
                class="text-danger"
                v-if="errors.has('form-1.Tandatangan Putusan')"
              >
                {{ errors.first("form-1.Tandatangan Putusan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="File Map Memo: ">
              <b-form-file
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                plain
                class="form-control"
                v-model="dataPerDokumen.file_map_memo"
                v-validate="'required'"
                name="File Map Memo"
                accept="image/*"
                :class="{ 'is-invalid': errors.has('form-1.File Map Memo') }"
              ></b-form-file>
              <span
                class="text-danger"
                v-if="errors.has('form-1.File Map Memo')"
              >
                {{ errors.first("form-1.File Map Memo") }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="onSubmit">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal catatan memo -->
    <div
      class="modal fade catatan"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content" style="background-color: white">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Catatan</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: white">
            <div>
              <table id="example2" class="table" style="width: 100%">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Nama Pengirim</th>
                    <!-- <th>Jabatan Pengirim</th> -->
                    <th>Status</th>
                    <th>Catatan</th>
                    <th>Tanggal</th>
                    <th>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="data in dataCatatanMemo" :key="data.id">
                    <td></td>
                    <td>{{ data.nama_pengirim }}</td>
                    <!-- <td>
                                                {{data.jabatan_pengirim}}
                                            </td> -->
                    <td>
                      {{ data.status }}
                    </td>
                    <td>
                      <div v-html="data.isi_catatan"></div>
                    </td>
                    <td>
                      {{
                        new Date(data.createdAt).toLocaleDateString(
                          "id-ID",
                          options
                        )
                      }}
                      <br />
                      {{ new Date(data.createdAt).toLocaleTimeString() }}
                    </td>
                    <td>
                      <div>
                        <button
                          data-toggle="modal"
                          data-target="#modal-catatan"
                          @click="getPerCatatanMemo(data.id)"
                          style="margin: 5px"
                          class="btn btn-secondary"
                        >
                          <i class="fa fa-eye"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- modal detail catatan -->
    <div
      class="modal fade"
      id="modal-catatan"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Detail Catatan {{ detailCatatan.nama_pengirim }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: white">
            <form ref="form" @submit.stop.prevent="tambahcatatan">
              <b-col md="12">
                <div class="form-group">
                  <b-form-group label="Detail Catatan :">
                    <!-- <b-form-textarea
                                                id="textarea-formatter"
                                                v-html="detailCatatan.isi_catatan "
                                                
                                            ></b-form-textarea> -->
                    <ckeditor
                      :editor="wygEditor"
                      v-model="detailCatatan.isi_catatan"
                    ></ckeditor>
                  </b-form-group>
                </div>
              </b-col>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      body-class="bg-white"
      id="modal-bayar"
      title="Upload Pembayaran"
      cancel-title="Close"
      ok-title="Accept"
      cancel-variant="outline-secondary"
    >
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
          <b-col md="12">
            <b-form-group label="File Bukti Pembayaran: *" label-for="username">
              <b-form-file
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                plain
                class="form-control"
                v-model="dataPerDokumen.bukti_pembayaran"
                accept=".pdf"
              ></b-form-file>
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            style="float: right"
            @click="onSubmitPembayaran"
          >
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      body-class="bg-white"
      id="modal-upload-final-surat"
      title="Unggah Final Surat Persetujuan Menteri"
      cancel-title="Close"
      ok-title="Accept"
      cancel-variant="outline-secondary"
    >
      <form ref="form" data-vv-scope="form-1">
        <b-row>
          <b-col md="12">
            <b-form-group label="Nomor KKP: *">
              <input
                :class="{ 'form-control': true }"
                type="txt"
                v-validate="'required'"
                name="Nomor KKP"
                v-model="formFinalSurat.nomor_kkp"
              />
            </b-form-group>

            <b-form-group label="File Surat Persetujuan: *" label-for="username">
              <b-form-file
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                plain
                class="form-control"
                v-model="formFinalSurat.file_izin_ttd"
                accept=".pdf"
              ></b-form-file>
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            style="float: right"
            @click="simpanFinalSurat"
          >
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import vSelect from "vue-select";
import axios from "axios";
import VueLoading from "vuejs-loading-plugin";
import Swal from "sweetalert2";

// using default options
Vue.use(VueLoading);

// overwrite defaults
Vue.use(VueLoading, {
  dark: true, // default false
  text: "Loading", // default 'Loading'
  loading: true, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  background: "rgb(255,255,255)", // set custom background
  classes: ["myclass"], // array, object or string
});
export default {
  components: { ClassicEditor, vSelect },
  data() {
    return {
      fields: [
        "no",
        { key: "nama_pemohon", sortable: true },
        { key: "nomor_permohonan", sortable: true },
        { key: "jenis_kegiatan", sortable: true },
        {
          key: "status_verdok",
          label: "Status Verifikasi Dokumen",
          sortable: true,
        },
        {
          key: "status_vertek",
          label: "Status Penilaian Teknis",
          sortable: true,
        },
        { key: "tanggal_pada_permohonan", label: "Tanggal Permohonan" },
        { key: "tanggal_berlaku", label: "Tanggal Berlaku Tagihan" },
        { key: "tagihan", label: "Tagihan" },
        { key: "file_ba", label: "File BA" },
        { key: "file_memo", label: "File Memo" },
        "Aksi",
      ],
      optionsDatatable: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: "", count: "", limit: "" },
        columnsClasses: { id: "width-100" },
        skin: "table table-striped",
        sortIcon: {
          base: "fa text-muted",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
      },

      // currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      dataPerDokumen: [],
      wygEditor: ClassicEditor,
      dataTTD: [],
      dataPermohonan: [],
      dataCatatanMemo: [],
      detailCatatan: [],
      selectedFile: null,
      nomorBA: null,
      formFinalSurat: {
        id: null,
        nomor_kkp: null,
        file_izin_ttd: null
      },
      idpermohonan:null
    };
  },
  props: {
    itemsWithNumber: {
      type: Array,
      default: () => {
        return [];
      },
    },
    dataJenisProyek: {
      type: Array,
      default: () => {
        return [];
      },
    },
    user: {
      type: Array,
      default: () => {
        return [];
      },
    },
    baseapi: String,
    dataRisiko: {
      type: Array,
      default: () => {
        return [];
      },
    },
    dataSkalaUsaha: {
      type: Array,
      default: () => {
        return [];
      },
    },
    dataStatusVerdok: {
      type: Array,
      default: () => {
        return [];
      },
    },
    rows: Number,
    tipe: String,

    totalRows: Number,
    currentPage: Number,
  },
  mounted() {
    this.getdata();
    this.getDataTTD();
  },
  methods: {
    onFiltered(data) {
      this.$emit("onFiltered", data);
    },
    pilihModal() {
      this.$emit("pilihModal");
    },
    deleteDokumen(data) {
      this.$emit("deleteDokumen", data);
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD MMMM YYYY");
      }
    },

    getdata() {
      $("#example").DataTable().destroy();
      this.loaddata();
    },

    finalBA() {
      this.$validator.validateAll("form-1").then((result) => {
        if (result) {
          this.$nextTick(() => {
            this.$bvModal.hide("modal-final-ba");
          });
          this.$loading(true);
          axios
            .put(
              this.baseapi +
                "api/permohonan_nonberusaha/generate_ba/" +
                this.idpermohonan,
              {
                nomor_ba_vertek: this.nomorBA,
              },
              {
                headers: {
                  "Content-type": "application/json",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$loading(false);
              this.$toasted.success("Berhasil Disimpan");
              this.getdata();
              this.dataPerDokumen = [];
              //   this.dataUser = []

              // Wait until the models are updated in the UI
              return res;
            })
            .catch((err) => {
              this.$loading(false);
              console.log(err);
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      });
    },
    
    // finalMemo() {
    //   Swal.fire({
    //     title: "Informasi",
    //     text: "Apakah Anda yakin ingin finalisasi Memo?",
    //     icon: "question",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "Ya, Finalisasi Memo",
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       this.$loading(true);
    //       axios
    //         .post(
    //           this.baseapi + "api/permohonan_nonberusaha/" + this.idpermohonan,
    //           {
    //             status_pembuatan_memorandum: "Selesai",
    //           },
    //           {
    //             headers: {
    //               "Content-type": "application/json",
    //               Authorization: `Bearer ` + this.user.accessToken,
    //             },
    //           }
    //         )
    //         .then((res) => {
    //           this.$loading(false);
    //           this.$toasted.success("Berhasil Disimpan");
    //           this.getdata();
    //           this.dataPerDokumen = [];
    //           //   this.dataUser = []

    //           // Wait until the models are updated in the UI
    //           return res;
    //         })
    //         .catch((err) => {
    //           this.$loading(false);
    //           console.log(err);
    //           this.$toasted.error(err.response.data.message);
    //           return err;
    //         });
    //     }
    //   });
    // },
    finalMemo() {
        this.$validator.validateAll('form-1').then((result) => {
            if (result) {
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-final-memo')
                });
                this.$loading(true);
                axios.post(this.baseapi + 'api/permohonan_nonberusaha/' + this.idpermohonan, {
                    nomor_kkp: this.dataPerDokumen.nomor_kkp,
                    // "status_pembuatan_memorandum": "Selesai"
                },
                    {
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ` + this.user.accessToken
                        }
                    })
                    .then((res) => {
                        this.$loading(false);
                        this.$toasted.success("Berhasil Disimpan");
                        this.getdata()
                        this.dataPerDokumen = []
                        //   this.dataUser = []

                        // Wait until the models are updated in the UI
                        return res;
                    })
                    .catch((err) => {
                        this.$loading(false);
                        console.log(err)
                        this.$toasted.error(err.response.data.message);
                        return err;
                    });
            }
        })
    },

    initDatatable() {
      setTimeout(() => {
        $.fn.dataTable.moment("DD MMMM YYYY");

        var t = $("#example").DataTable({
          pagingType: "full_numbers",
          language: {
            info: "Menampilkan _START_ sampai _END_ dari _TOTAL_ data",
            paginate: {
              first: "Awal",
              last: "Akhir",
              next: "Selanjutnya",
              previous: "Sebelumnya",
            },
          },
          stateSave: true,
          order: [[8, 'desc']],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: {
            left: 3,
            right: 1,
          },
          scrollX: true,
          dom: "Bfrtip",
          fnRowCallback: function (
            nRow,
            aData,
            iDisplayIndex,
            iDisplayIndexFull
          ) {
            //debugger;
            var index = iDisplayIndexFull + 1;
            $("td:first", nRow).html(index);
            return nRow;
          },
          columnDefs: [
          // { type: 'date-dd-mmm-yyyy', targets: 8 },
            {
              targets: 0,
              render: function (data, type, row, meta) {
                console.log(meta.row);
                console.log(type == "export" ? meta.row : data);
                return type == "export" ? meta.row + 1 : data;
              },
            },
          ],
          buttons: [
            // 'excel', 'pdf',
            {
              extend: "excelHtml5",
              title: "DATA PEMOHON",
              text: '<i class="fa fa-file-text-o"></i> Excel',
              className: "btn text-white btn-success",
              exportOptions: {
                columns: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                orthogonal: "export",
                // format: {
                //     header: function ( data, columnIdx ) {
                //         if(columnIdx==7 || columnIdx==8 || columnIdx==9){
                //         return 'Aktivitas ' + data;
                //         }
                //         else if(columnIdx==10 || columnIdx==11){
                //           return 'Verifikasi Dokumentatif ' + data;
                //         }
                //         else if(columnIdx==12 || columnIdx==13){
                //           return 'Verifikasi Lapangan ' + data;
                //         }
                //         else if(columnIdx==14 || columnIdx==15){
                //           return 'File BA ' + data;
                //         }
                //         else if(columnIdx==16 || columnIdx==17 || columnIdx==18){
                //           return 'Predikat ' + data;
                //         }
                //         else{
                //           return data;
                //         }
                //     },
                //     body: function(data, row, column, node) {
                //         data = $('<p>' + data + '</p>').text();
                //         return data.replace(',', '.');
                //     },
                // }
              },
              filename: function () {
                var today = new Date();
                // var n = d.getTime();
                var date =
                  today.getFullYear() +
                  "-" +
                  (today.getMonth() + 1) +
                  "-" +
                  today.getDate();

                return "Data Pemohon " + date;
              },
            },
          ],
        });
        t.on("order.dt search.dt", function () {
          t.column(0, { search: "applied", order: "applied" })
            .nodes()
            .each(function (cell, i) {
              cell.innerHTML = i + 1;
            });
        }).draw();
      }, 300);
    },

    loaddata() {
      //   var api;
      //   if (this.user.role == 'pic') {
      //     api = 'api/permohonan?filter=pic_id,=,'+this.user.id
      //   } else {
      //     api = 'api/permohonan'
      //   }
      axios
        .get(
          this.baseapi +
            "api/permohonan_nonberusaha?filter=tipe_pemohon,=," +
            this.tipe +
            ";pic_monitor_id,=," +
            this.user.id,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.dataPermohonan = response.data.data;

          for (let index = 0; index < this.dataPermohonan.length; index++) {
            Vue.set(this.dataPermohonan[index], "selectedFile", null);
          }
          this.initDatatable();
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getBayar(id) {
      axios
        .get(this.baseapi + "api/permohonan_nonberusaha/" + id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataPerDokumen = response.data.data;
          this.$bvModal.show("modal-bayar");
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    onSubmitPembayaran() {
      console.log("cok");
      this.$nextTick(() => {
        this.$bvModal.hide("modal-bayar");
      });
      this.$loading(true);
      let formData = new FormData();
      formData.append("bukti_pembayaran", this.dataPerDokumen.bukti_pembayaran);
      axios
        .post(
          this.baseapi + "api/permohonan_nonberusaha/" + this.dataPerDokumen.id,
          formData,
          {
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((res) => {
          this.$loading(false);
          this.$toasted.success("Berhasil Disimpan");
          this.dataPerDokumen = [];
          this.getdata();
          return res;
        })
        .catch((err) => {
          this.$loading(false);
          console.log(err);
          this.$toasted.error(err.response.data.message);
          // this.$bvModal.hide('modal-pembayaran')
          return err;
        });
    },

    getDetailPerDokumen(id) {
      axios
        .get(this.baseapi + "api/permohonan_nonberusaha/" + id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataPerDokumen = response.data.data;
          if (this.dataPerDokumen.paraf_1_memo_1 == 0) {
            this.dataPerDokumen.paraf_1_memo_1 = null;
          }
          if (this.dataPerDokumen.paraf_1_memo_2 == 0) {
            this.dataPerDokumen.paraf_1_memo_2 = null;
          }

          if (this.dataPerDokumen.paraf_2_memo_1 == 0) {
            this.dataPerDokumen.paraf_2_memo_1 = null;
          }

          if (this.dataPerDokumen.paraf_2_memo_2 == 0) {
            this.dataPerDokumen.paraf_2_memo_2 = null;
          }

          if (this.dataPerDokumen.paraf_3_memo_2 == 0) {
            this.dataPerDokumen.paraf_3_memo_2 = null;
          }

          if (this.dataPerDokumen.paraf_1_putusan == 0) {
            this.dataPerDokumen.paraf_1_putusan = null;
          }

          if (this.dataPerDokumen.paraf_2_putusan == 0) {
            this.dataPerDokumen.paraf_2_putusan = null;
          }

          if (this.dataPerDokumen.paraf_3_putusan == 0) {
            this.dataPerDokumen.paraf_3_putusan = null;
          }

          if (this.dataPerDokumen.paraf_4_putusan == 0) {
            this.dataPerDokumen.paraf_4_putusan = null;
          }

          if (this.dataPerDokumen.paraf_5_putusan == 0) {
            this.dataPerDokumen.paraf_5_putusan = null;
          }

          if (this.dataPerDokumen.ttd_memo_1 == 0) {
            this.dataPerDokumen.ttd_memo_1 = null;
          }

          if (this.dataPerDokumen.ttd_memo_2 == 0) {
            this.dataPerDokumen.ttd_memo_2 = null;
          }

          if (this.dataPerDokumen.ttd_putusan == 0) {
            this.dataPerDokumen.ttd_putusan = null;
          }

          if (this.dataPerDokumen.status_pembuatan_memorandum != null) {
            if (
              this.dataPerDokumen.status_pembuatan_memorandum ===
              "Menunggu paraf dari Subkoordinator pada Memo Direktur ke Dirjen"
            ) {
              this.$bvModal.show("modal-memo");
            } else if (
              this.dataPerDokumen.status_pembuatan_memorandum.includes(
                "Menunggu"
              )
            ) {
              Swal.fire({
                icon: "info",
                title: this.dataPerDokumen.status_pembuatan_memorandum,
              });
            } else if (
              this.dataPerDokumen.status_pembuatan_memorandum.includes(
                "Catatan"
              )
            ) {
              // this.getCatatanMemo()
              Swal.fire({
                icon: "question",
                title: "Silahkan Pilih",
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: "Unduh Memo",
                denyButtonText: `Perbaikan Memo`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  window.open(
                    this.dataPerDokumen.file_konsep_memorandum,
                    "_blank"
                  );
                } else if (result.isDenied) {
                  this.$bvModal.show("modal-memo");
                }
              });
            } else if (
              this.dataPerDokumen.status_pembuatan_memorandum.includes(
                "Sudah ditandatangani"
              )
            ) {
              this.finalMemo()
              // this.$bvModal.show("modal-final-memo");
            } else if (
              this.dataPerDokumen.status_pembuatan_memorandum == "Selesai"
            ) {
              Swal.fire({
                icon: "info",
                title: "Unduh Surat Tugas",
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: "Unduh",
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  window.open(
                    this.dataPerDokumen.file_final_memorandum,
                    "_blank"
                  );
                }
              });
            }
          } else {
            this.$bvModal.show("modal-memo");
          }
          //   if (this.dataPerDokumen.status_pembuatan_memorandum.includes("Menunggu") ) {
          //         Swal.fire({
          //             icon: 'info',
          //             title: this.dataPerDokumen.status_pembuatan_memorandum ,
          //         })
          //     } else if (this.dataPerDokumen.status_pembuatan_memorandum.includes("Catatan") ) {
          //         this.getCatatanSurat()
          //         Swal.fire({
          //             icon: 'question',
          //             title: 'Silahkan Pilih',
          //             showDenyButton: true,
          //             showCancelButton: true,
          //             confirmButtonText: 'Unduh Memo',
          //             denyButtonText: `Perbaikan Memo`,
          //             }).then((result) => {
          //                 /* Read more about isConfirmed, isDenied below */
          //                 if (result.isConfirmed) {
          //                     window.open(this.dataPerDokumen.file_konsep_memorandum, '_blank');
          //                 } else if (result.isDenied) {
          //                     this.$bvModal.show('modal-memo')
          //                 }
          //             })
          //     } else if(this.dataPerDokumen.status_pembuatan_memorandum.includes("Sudah ditandatangani")){
          //         this.$bvModal.show('modal-final-memo')
          //     } else if (this.dataPerDokumen.status_pembuatan_memorandum  == 'Selesai'){
          //         Swal.fire({
          //             icon: 'info',
          //             title: 'Unduh Surat Tugas',
          //             showDenyButton: false,
          //             showCancelButton: false,
          //             confirmButtonText: 'Unduh',
          //             }).then((result) => {
          //             /* Read more about isConfirmed, isDenied below */
          //                 if (result.isConfirmed) {
          //                     window.open(this.dataPerDokumen.file_final_memorandum, '_blank');
          //                 }
          //             })
          //     }
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getCatatanMemo(id) {
      $("#example2").DataTable().destroy();
      axios
        .get(this.baseapi + "api/catatan_memo?filter=id_permohonan,=," + id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataCatatanMemo = response.data.data;
          this.initDatatable2();
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getPerCatatanMemo(id) {
      axios
        .get(this.baseapi + "api/catatan_memo/" + id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.detailCatatan = [];
          this.detailCatatan.nama_pengirim = response.data.data.nama_pengirim;
          if (response.data.data.isi_catatan == null) {
            this.detailCatatan.isi_catatan = "";
          } else {
            this.detailCatatan.isi_catatan = response.data.data.isi_catatan;
          }
          console.log(this.detailCatatan);
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    initDatatable2() {
      setTimeout(() => {
        var t = $("#example2").DataTable({
          pagingType: "full_numbers",
          language: {
            info: "Menampilkan _START_ sampai _END_ dari _TOTAL_ data",
            paginate: {
              first: "Awal",
              last: "Akhir",
              next: "Selanjutnya",
              previous: "Sebelumnya",
            },
          },
          // order: [[0, 'desc']],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: {
            left: 2,
            right: 1,
          },
          scrollX: true,
          // dom: 'Bfrtip',
          // "fnRowCallback": function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          //     //debugger;
          //     var index = iDisplayIndexFull + 1;
          //     $("td:first", nRow).html(index);
          //     return nRow;
          //   },
          //   columnDefs: [{
          //     targets: 0,
          //     render: function(data, type, row, meta) {
          //     console.log(meta.row);
          //     console.log(type == 'export'? meta.row : data);
          //       return type == 'export'? meta.row + 1 : data;
          //     }
          //   }],
        });

        // t.on( 'click', 'button', function (e) {
        //     var closestRow = $(this).closest('tr');
        //     var data = t.row( $(this).parents(closestRow)).data();
        //     alert(data[0])
        //     // alert( t.cell( $(this).closest('tr').prev('tr'), $(this).attr('data-dtr-index') ).data() );
        // e.stopPropagation();

        // } );
        t.on("order.dt search.dt", function () {
          t.column(0, { search: "applied", order: "applied" })
            .nodes()
            .each(function (cell, i) {
              cell.innerHTML = i + 1;
            });
        }).draw();
      }, 300);
    },

    getDataTTD() {
      axios
        .get(this.baseapi + "api/tandatangan", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataTTD = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    onSubmit() {
      this.$nextTick(() => {
        this.$bvModal.hide("modal-memo");
      });
      this.$loading(true);
      this.$validator.validateAll("form-1").then((result) => {
        if (result) {
          let formData = new FormData();
          formData.append("paraf_1_memo_1", this.dataPerDokumen.paraf_1_memo_1);
          formData.append("paraf_2_memo_1", this.dataPerDokumen.paraf_2_memo_1);
          formData.append("ttd_memo_1", this.dataPerDokumen.ttd_memo_1);
          formData.append("paraf_1_memo_2", this.dataPerDokumen.paraf_1_memo_2);
          formData.append("paraf_2_memo_2", this.dataPerDokumen.paraf_2_memo_2);
          formData.append("paraf_3_memo_2", this.dataPerDokumen.paraf_3_memo_2);
          formData.append("ttd_memo_2", this.dataPerDokumen.ttd_memo_2);
          formData.append(
            "paraf_1_putusan",
            this.dataPerDokumen.paraf_1_putusan
          );
          formData.append(
            "paraf_2_putusan",
            this.dataPerDokumen.paraf_2_putusan
          );
          formData.append(
            "paraf_3_putusan",
            this.dataPerDokumen.paraf_3_putusan
          );
          formData.append(
            "paraf_4_putusan",
            this.dataPerDokumen.paraf_4_putusan
          );
          formData.append(
            "paraf_5_putusan",
            this.dataPerDokumen.paraf_5_putusan
          );
          formData.append("ttd_putusan", this.dataPerDokumen.ttd_putusan);
          formData.append("file_map_memo", this.dataPerDokumen.file_map_memo);
          axios
            .post(
              this.baseapi +
                "api/permohonan_nonberusaha/" +
                this.dataPerDokumen.id,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$loading(false);
              this.$toasted.success("Berhasil Membuat Memo");
              this.getdata();
              this.dataPerDokumen = [];

              // Wait until the models are updated in the UI
              return res;
            })
            .catch((err) => {
              this.$loading(false);
              console.log(err);
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      });
    },

    detailFinalSurat(data) {
      this.formFinalSurat.id = data.id;
      this.formFinalSurat.nomor_kkp = data.nomor_kkp;
      this.formFinalSurat.file_izin_ttd = data.file_izin_ttd;

      this.$bvModal.show("modal-upload-final-surat");
    },

    simpanFinalSurat() {
      this.$bvModal.hide("modal-upload-final-surat");
      this.$loading(true);
      let formData = new FormData();
      formData.append("nomor_kkp", this.formFinalSurat.nomor_kkp);
      formData.append("file_izin_ttd", this.formFinalSurat.file_izin_ttd);

      axios
        .post(
          this.baseapi + "api/permohonan_nonberusaha/" + this.formFinalSurat.id,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((res) => {
          this.$loading(false);
          this.$toasted.success("Berhasil Unggah File Final Surat Persetujuan");
          this.getdata();
          this.dataPerDokumen = [];

          // Wait until the models are updated in the UI
          return res;
        })
        .catch((err) => {
          this.$loading(false);
          console.log(err);
          this.$toasted.error(err.response.data.message);
          return err;
        });
    },

    tandaTanganMKP(id) {
      Swal.fire({
        title: "Informasi",
        text: "Apakah Anda yakin ingin meminta tanda tangan elektronik Menteri Kelautan dan Perikanan?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$loading(true);
          axios
            .post(
              this.baseapi + "api/permohonan_nonberusaha/" + id,
              {
                status_pembuatan_memorandum: "Menunggu tandatangan MKP",
              },
              {
                headers: {
                  "Content-type": "application/json",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$loading(false);
              this.$toasted.success("Berhasil Disimpan");
              this.getdata();
              this.dataPerDokumen = [];
              //   this.dataUser = []

              // Wait until the models are updated in the UI
              return res;
            })
            .catch((err) => {
              this.$loading(false);
              console.log(err);
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      });
    },

  },
};
</script>